"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.BasisTheoryService = void 0;

var _axios = _interopRequireDefault(require("axios"));

var _common = require("./../common");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

class BasisTheoryService {
  constructor(options) {
    const {
      apiKey,
      baseURL,
      transformRequest,
      transformResponse,
      appInfo
    } = options;

    if (typeof _axios.default === 'string') {
      // known issue with create react app
      // eslint-disable-next-line unicorn/prefer-type-error
      throw new Error('basis-theory-js@1.77.0+ and basis-theory-react@1.12.1+ are not supported with CRA 5, go to https://github.com/Basis-Theory/basis-theory-js/issues/365#issuecomment-1662883062 for workarounds.');
    } else {
      this.client = _axios.default.create({
        baseURL,
        headers: {
          [_common.API_KEY_HEADER]: apiKey,
          [_common.CLIENT_USER_AGENT_HEADER]: (0, _common.buildClientUserAgentString)(appInfo),
          ...(typeof window === 'undefined' && {
            [_common.USER_AGENT_HEADER]: (0, _common.buildUserAgentString)(appInfo)
          })
        },

        /* eslint-disable unicorn/prefer-spread */
        transformRequest: [].concat(transformRequest || _common.transformRequestSnakeCase, _axios.default.defaults.transformRequest),
        transformResponse: _axios.default.defaults.transformResponse.concat(transformResponse || _common.transformResponseCamelCase)
        /* eslint-enable unicorn/prefer-spread */

      });
      this.client.interceptors.response.use(undefined, _common.errorInterceptor);
    }
  }

}

exports.BasisTheoryService = BasisTheoryService;